// Prix PUBLIC de référence — AFFICHAGE UNIQUEMENT.
//
// ⚠️ RÈGLE ABSOLUE : ces valeurs ne doivent JAMAIS intervenir dans un calcul de
// paiement. Les montants réellement facturés proviennent EXCLUSIVEMENT de
// `getPrice()` et de la table `PRICING` (src/lib/payments/pricing.ts), devise
// par devise. Ce module est volontairement SÉPARÉ de pricing.ts pour que cette
// frontière soit physique et non seulement documentaire.
//
// SOURCE UNIQUE : toute surface publique affichant le prix (landing, page
// tarifs, métadonnées SEO, Payment Hub) consomme ces constantes. C'est ce qui
// empêche la réapparition d'un prix divergent — l'incident du « 29 € » venait
// d'un montant écrit en dur à plusieurs endroits.
//
// Changer le prix public = éditer CE fichier, et lui seul.

export const REFERENCE_PRICE = {
  /** Montant affiché — mis en avant sur les cartes tarifaires. */
  amount: '20 €',
  /** Périodicité affichée à côté du montant. */
  period: '/ mois',
  /**
   * Valeur numérique du prix de référence, et sa devise.
   *
   * ⚠️ RÉSERVÉ AUX AGRÉGATS INFORMATIFS — aujourd'hui le seul usage est le
   * « revenu simulé » du panneau d'administration. Ce n'est PAS un encaissement :
   * les débits se font en devise locale, et tous les abonnés ne paient pas le
   * même mois.
   *
   * ⛔ JAMAIS pour un montant débité, remboursé ou comparé à un paiement. Ces
   * montants viennent EXCLUSIVEMENT de `getPrice()` (payments/pricing.ts). La
   * règle « ce module n'entre pas dans un calcul de paiement » reste entière :
   * un agrégat d'administration n'est pas un calcul de paiement.
   */
  numeric: 20,
  currency: 'EUR',
} as const

/** Libellé combiné pour les phrases et métadonnées : « 20 €/mois ». */
export const REFERENCE_PRICE_LABEL = `${REFERENCE_PRICE.amount}/mois`

/**
 * Séparateur de milliers à la française, SANS passer par `Intl`.
 *
 * Pourquoi pas `toLocaleString('fr-FR')`. Node produit U+202F (espace fine
 * insécable) comme séparateur, et la valeur exacte dépend de la version d'ICU
 * embarquée. Sur une chaîne rendue CÔTÉ SERVEUR puis réhydratée par le
 * navigateur, les deux ICU peuvent diverger — la landing affiche « 1 300 crédits »
 * dans un composant rendu au build, donc le cas est réel, pas théorique.
 * Mesuré : `(1300).toLocaleString('fr-FR')` vaut ici `1\u202F300`.
 *
 * ⚠️ DUPLICATION ASSUMÉE : `payment-confirmation.ts` porte un `formatAmount`
 * identique, privé, pour la même raison et documenté de la même façon. Il n'est
 * pas importé ici — ce module d'affichage ne doit dépendre d'aucun fichier du
 * chemin de paiement, c'est la frontière physique posée en tête de fichier.
 */
export function formatCreditCount(n: number): string {
  return String(Math.trunc(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}
